import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ContactUsLayer from "../components/ContactUsLayer";

const ContactUsPage = () => {
    return (
        <MasterLayout>
            <ContactUsLayer />
        </MasterLayout>
    );
};

export default ContactUsPage;
